import React from 'react';
import Sidebar from './sidebar';
import FooterStyle from './footer';
import { Link } from 'react-router-dom'; // Import Link from React Router
import { PropertyCard } from './propertycard';


export const AwardsPage = () => {
  return (
    <div className='top-layout'>
      <div className='Navbar'>
        <Sidebar />
      </div>
    
      <div className='layout'>

        <div className='KS-logo'>
          <Link to="/" style={{ position:'absolute', cursor: 'pointer', zIndex: '100'}}>
            <img src={process.env.PUBLIC_URL + '/images/KS_logo.png'} alt="Logo" style={{ width: '4.5rem', marginTop:'0.3rem'}} />
          </Link>
        </div>

        <div className='backgroundImage'>
          <img src={process.env.PUBLIC_URL + '/images/RESORTS/Gayana Marine Resort.jpg'} alt="headImage" style={{ width: '100%', position:'relative', top:'7rem' }} />  
          <h1>AWARDS & RECOGNITION</h1>
        </div>


        <div className='awards-content'>

          <div className='awards-card'>
              <div className='awards-card-content'>
                <PropertyCard
                  imageUrl={process.env.PUBLIC_URL + '/images/AWARDS/award1.jpg'}
                  title={'2008 - 2009 Malaysia tourism Awards Most Innovative Tourist Attraction Eco-Tourism Conservative Winner'}
                  style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', margin:'2rem'}}
                />
                <PropertyCard 
                  imageUrl={process.env.PUBLIC_URL + '/images/AWARDS/award2.jpg'}
                  title={'2010 Malaysia Property Award Resort Development Winner'}
                  style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
                />
                <PropertyCard 
                  imageUrl={process.env.PUBLIC_URL + '/images/AWARDS/award3.jpg'}
                  title={"2011 Prtx d'Excellence Award Resort Category Winner"}
                  style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
                />
                <PropertyCard 
                  imageUrl={process.env.PUBLIC_URL + '/images/AWARDS/award4.jpg'}
                  title={'2017 - 2018 Asia Pacific Property Awards Hotel Interior Design Winner'}
                  style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
                />
                <PropertyCard 
                  imageUrl={process.env.PUBLIC_URL + '/images/AWARDS/award5.jpg'}
                  title={'2020 - Anugerah Pengurusan Penyenggaraan Terbaik Bangunan Gunasama Persekutuan Tahun 2020'}
                  style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
                />
                <PropertyCard 
                  imageUrl={process.env.PUBLIC_URL + '/images/AWARDS/award6.jpg'}
                  title={'2022 - Anugerah Pengurusan Penyenggaraan Terbaik Bangunan Gunasama Persekutuan Tahun 2022'}
                  style={{ boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'}}
                />
              </div>
          </div>

        </div>


        <div className='footer'>
          <FooterStyle />
        </div>

      </div>

      

    </div>
  );
}

export default AwardsPage;
